/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Chat_Role_DriverInputs */

const en_case_chat_role_driver = /** @type {(inputs: Case_Chat_Role_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver`)
};

const pt_br2_case_chat_role_driver = /** @type {(inputs: Case_Chat_Role_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condutor`)
};

/**
* | output |
* | --- |
* | "Driver" |
*
* @param {Case_Chat_Role_DriverInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_role_driver = /** @type {((inputs?: Case_Chat_Role_DriverInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Role_DriverInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_role_driver(inputs)
	return pt_br2_case_chat_role_driver(inputs)
});